import HttpCliente from "../HttpCliente";

// Obtener todas las obligaciones
export const getObligaciones = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Obligacion/ObtenerObligaciones", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener obligaciones habilitadas
export const getObligacionesHabilitadas = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Obligacion/ObtenerObligacionesHabilitadas", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Obtener obligaciones de un cliente específico
export const getObligacionesCliente = (token, idUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Obligacion/ObtenerObligacionesCliente/${idUsuario}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

// Crear nueva obligación
export const crearObligacion = (token, obligacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Obligacion/CrearObligacion", obligacion, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const editarObligacion = (token, obligacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Obligacion/EditarObligacion", obligacion, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

// Obtener obligaciones por normativa
export const getObligacionNormativa = (token, idNormativa) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Obligacion/ObtenerObligacionNormativa/${idNormativa}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};